const translation = {
  // Navbar
  nav_used_pallets: "Used Pallets",
  nav_new_pallets: "New Pallets",
  nav_services: "Services",
  nav_about: "About Us",
  nav_faq: "FAQ",
  nav_contact: "Contact",
  nav_get_quote: "Get Quote",

  // Hero
  hero_location: "Antwerp, Belgium",
  hero_title_line1: "PREMIUM",
  hero_title_line2: "EURO PALLETS",
  hero_subtitle: "Trusted supplier of Grade A, Grade B used pallets & new wooden pallets. Quality inspected. Fast delivery across Belgium.",
  hero_cta_quote: "Request a Quote",
  hero_cta_products: "View Products",

  // Stats
  stat_years: "Years Experience",
  stat_pallets: "Pallets Delivered",
  stat_grades: "Product Grades",
  stat_quality: "Quality Inspected",

  // Gallery
  gallery_label: "Quality You Can See",
  gallery_title: "Our Pallet Collection",
  gallery_grade_a: "Grade A Premium",
  gallery_grade_b: "Grade B Value",
  gallery_new: "New Pallets",
  gallery_custom: "Custom Orders",

  // How It Works
  how_label: "Simple Process",
  how_title: "How It Works",
  how_subtitle: "From browsing to delivery, we make ordering pallets fast and straightforward.",
  how_step1_title: "Browse & Select",
  how_step1_desc: "Explore our range of Grade A, Grade B, and new wooden pallets. View detailed specs and photos to find exactly what you need.",
  how_step2_title: "Request Quote / Order",
  how_step2_desc: "Submit a quote request or place a direct order online. We'll confirm pricing, availability, and delivery details within 24 hours.",
  how_step3_title: "Fast Delivery",
  how_step3_desc: "Receive your pallets quickly across Belgium and Europe. All orders are quality-checked before dispatch.",

  // Used Pallets
  used_label: "Quality Used Pallets",
  used_title: "Used Euro Pallets",
  used_subtitle: "Choose from Grade A premium quality or Grade B cost-effective pallets. All inspected and ready for immediate use.",

  // New Pallets
  new_label: "Brand New Pallets",
  new_title: "New Wooden Pallets",
  new_subtitle: "ISPM15 certified, export-ready pallets manufactured to the highest standards. Custom sizes available.",

  // Pricing
  pricing_label: "Transparent Pricing",
  pricing_title: "Volume Pricing Tiers",
  pricing_subtitle: "Competitive prices with bulk discounts. The more you order, the more you save.",
  pricing_grade_a: "Grade A Pallets",
  pricing_grade_b: "Grade B Pallets",  
  pricing_new: "New Pallets",
  pricing_tier_1: "10-100 pieces",
  pricing_tier_2: "100-500 pieces", 
  pricing_tier_3: "500-5000 pieces",
  pricing_tier_4: "5000+ pieces",
  pricing_per_pallet: "per pallet",
  pricing_contact: "Contact for custom pricing on larger quantities",

  // Product card
  product_quick_specs: "Quick Specs",
  product_dimensions: "Dimensions",
  product_load: "Load Capacity",
  product_wood: "Wood Type",
  product_order_now: "Order Now",
  product_view_details: "View Details",
  product_view_angles: "View Angles & Details",
  product_tech_specs: "Technical Specifications",
  product_key_features: "Key Features",
  product_request_quote: "Request Quote for This Product",
  product_call_us: "Call Us",
  product_pricing_tiers: "Volume Pricing",
  product_quantity: "Quantity",
  product_price_per_pallet: "Price per pallet",
  product_total_price: "Total price",
  product_current_tier: "Current pricing tier",

  // Pricing calculator
  calc_current_price: "Current Price",
  calc_volume_hint: "Volume pricing available - order more to save!",
  calc_total_price: "Total Price",
  calc_price_per: "Price per pallet",
  calc_quantity: "Quantity",
  calc_pallets: "pallets",
  calc_order_now: "Order",
  calc_current_selection: "Current Selection",
  calc_pieces: "pieces",
  calc_per_pallet: "per pallet",
  calc_calculate: "Calculate Your Order",
  calc_payment_methods: "PAYMENT METHODS AVAILABLE",
  calc_volume_pricing: "Volume Pricing",
  calc_bulk_discount: "Bulk discount applied",
  calc_min_order: "Minimum order: 10 pallets",
  calc_payment_methods_label: "Payment Methods:",
  calc_total: "Total:",
  calc_select_qty: "Select Quantity & Payment",
  calc_total_price_label: "Total Price",

  // Services
  services_label: "What We Do",
  services_title: "Our Services",
  services_subtitle: "From sorting and grading to delivery and custom orders, we provide complete pallet solutions for your business.",
  service1_title: "Pallet Sorting & Grading",
  service1_desc: "Expert manual inspection and grading of every pallet to ensure you receive exactly the quality you ordered.",
  service2_title: "Bulk Supply",
  service2_desc: "Large quantity orders welcome. Competitive pricing for bulk purchases with consistent quality across all pallets.",
  service3_title: "Custom Orders",
  service3_desc: "Need non-standard sizes or specifications? We manufacture custom wooden pallets tailored to your exact requirements.",
  service4_title: "Fast Delivery",
  service4_desc: "Reliable delivery across Belgium and Europe. Quick turnaround times to keep your operations running smoothly.",

  // Quality Grades
  quality_label: "Our Standards",
  quality_title: "Grade Quality System",
  quality_subtitle: "Every pallet we supply is carefully inspected and graded according to strict European standards. You always know exactly what you're getting.",
  grade_a_label: "Premium Grade",
  grade_b_label: "Standard Grade",
  grade_new_label: "Brand New",

  // About
  about_label: "Who We Are",
  about_title: "Antwerp's Trusted Pallet Partner",
  about_p1: "PEL Partner Company is a dedicated Euro pallet supplier based in Antwerp, Belgium. We provide businesses across Belgium and Europe with high-quality used and new wooden pallets — always inspected, always reliable.",
  about_p2: "Whether you need premium Grade A pallets for sensitive goods, cost-effective Grade B for general logistics, or brand-new pallets for export — we have the right solution at the right price.",
  about_location: "Antwerp, Belgium",
  about_quality: "Every pallet inspected",
  about_delivery: "Fast across Belgium",
  about_support: "Mon–Fri 8:00–18:00",
  about_years: "Years in Business",
  about_supplied: "Pallets Supplied",

  // Videos
  videos_label: "See It In Action",
  videos_title: "Our Operations",
  videos_subtitle: "Watch how we sort, inspect and prepare pallets to meet the highest quality standards before delivery.",
  tab_sorting: "Sorting Process",
  tab_quality: "Quality Check",
  tab_delivery: "Delivery",
  video_sorting_title: "Manual Sorting & Inspection",
  video_sorting_desc: "Every pallet is hand-checked for quality",
  video_strict: "Strict Inspection",
  video_strict_desc: "Every pallet is manually inspected for structural integrity, board condition, and EPAL compliance before leaving our facility.",
  video_sorted: "Sorted by Grade",
  video_sorted_desc: "Pallets are carefully sorted into Grade A, Grade B, and New categories so you always receive exactly what you ordered.",
  video_reliable: "Reliable Delivery",
  video_reliable_desc: "We deliver across Antwerp and Belgium with fast turnaround times. Large orders welcome — contact us for bulk pricing.",

  // Why Choose Us
  why_title: "Why Choose PEL Partner?",
  why1_title: "Certified Quality",
  why1_desc: "EPAL certified pallets, every batch inspected to European standards.",
  why2_title: "Competitive Pricing",
  why2_desc: "Best prices in Antwerp for Grade A, B and new pallets. Bulk discounts available.",
  why3_title: "Fast Turnaround",
  why3_desc: "Quick order processing and delivery across Belgium.",
  why4_title: "Reliable Partner",
  why4_desc: "Long-term relationships built on trust, consistency and quality.",

  // Delivery Areas
  delivery_label: "We Deliver Across Belgium",
  delivery_title: "Our Service Areas",
  delivery_subtitle: "Fast and reliable pallet delivery to major cities and regions throughout Belgium and Europe.",

  // FAQ
  faq_label: "Common Questions",
  faq_title: "Frequently Asked Questions",
  faq_subtitle: "Find answers to the most common questions about our pallets, services, and ordering process.",
  faq_q1: "What pallet grades do you offer?",
  faq_a1: "We offer three grades: Grade A (premium used pallets in excellent condition), Grade B (cost-effective used pallets with minor wear), and New Wooden Pallets (brand new, ISPM15 certified for export).",
  faq_q2: "What are your current pricing tiers?",
  faq_a2: "Grade A: €12 (10-100), €10 (100-500), €8.5 (500-5000), €7.5 (5000+). Grade B: €10 (10-100), €8 (100-500), €7 (500-5000), €6 (5000+). New Pallets: €20 (10-100), €15 (100-500), €12 (500-5000), €10 (5000+). All prices per pallet with bulk discounts available.",
  faq_q3: "What is the minimum order quantity?",
  faq_a3: "We accommodate orders starting from 10 pallets, with volume pricing tiers offering better rates for larger quantities. Contact us to discuss your specific requirements.",
  faq_q4: "Which areas do you deliver to?",
  faq_a4: "We deliver across Belgium, including Antwerp, Brussels, Ghent, Bruges, and Liège. We also serve customers throughout Europe. Contact us for delivery options to your location.",
  faq_q5: "What are your lead times?",
  faq_a5: "Grade A and Grade B used pallets are typically in stock and available for immediate delivery. New wooden pallets may require 1-2 weeks depending on quantity and customization. Contact us for current availability.",
  faq_q6: "Are your pallets EPAL certified?",
  faq_a6: "Yes, our Grade A pallets are EPAL certified and stamped. All new wooden pallets are ISPM15 heat-treated and stamped, making them fully compliant for international export.",
  faq_q7: "Do you offer custom pallet sizes?",
  faq_a7: "Yes, we can manufacture new wooden pallets in custom dimensions to meet your specific requirements. Standard EUR/EPAL size is 1200 × 800 mm, but we can accommodate other sizes on request.",
  faq_q8: "How do you ensure pallet quality?",
  faq_a8: "Every pallet we supply is manually inspected by our trained staff. We check for structural integrity, board condition, block damage, and compliance with EPAL standards before delivery.",
  faq_q9: "What payment methods do you accept?",
  faq_a9: "We accept bank transfers, credit cards, and can arrange payment terms for established business customers. Contact us to discuss payment options for your order.",

  // Contact
  contact_label: "Reach Out",
  contact_title: "Get In Touch",
  contact_info_title: "Contact Information",
  contact_phone_label: "Phone",
  contact_email_label: "Email",
  contact_location_label: "Location",
  contact_hours_label: "Business Hours",
  contact_hours_val: "Monday – Friday: 8:00 – 18:00",
  contact_call_now: "Call Now",
  contact_email_us: "Email Us",
  contact_quote_title: "Request a Quote",
  form_name: "Name",
  form_phone: "Phone",
  form_email: "Email",
  form_product: "Product",
  form_product_placeholder: "Select a product...",
  form_product_a: "Used Euro Pallets — Grade A",
  form_product_b: "Used Euro Pallets — Grade B",
  form_product_new: "New Wooden Pallets",
  form_product_mixed: "Mixed Order",
  form_message: "Message",
  form_message_placeholder: "Tell us about your requirements, quantity needed...",
  form_send: "Send Request",
  form_sending: "Sending...",
  form_success_title: "Message Sent!",
  form_success_desc: "We'll get back to you as soon as possible.",
  form_send_another: "Send Another",
  form_error: "Something went wrong. Please try again or contact us directly.",

  // Order Modal
  order_title: "Place Your Order",
  order_subtitle: "Fill in your details and we'll confirm your order within 24 hours.",
  order_company: "Company Name",
  order_company_ph: "Your company name",
  order_contact: "Contact Name",
  order_contact_ph: "Your full name",
  order_quantity: "Quantity",
  order_quantity_ph: "Number of pallets",
  order_address: "Delivery Address",
  order_address_ph: "Street, City, Postal Code",
  order_date: "Preferred Delivery Date",
  order_notes: "Additional Notes",
  order_notes_ph: "Any special requirements or questions...",
  order_cancel: "Cancel",
  order_review: "Review Order",
  order_summary_title: "Order Summary",
  order_summary_subtitle: "Please review your order details before submitting.",
  order_company_info: "Company Information",
  order_company_name_label: "Company Name",
  order_contact_label: "Contact Person",
  order_email_label: "Email",
  order_phone_label: "Phone",
  order_details: "Order Details",
  order_product_label: "Product",
  order_qty_label: "Quantity",
  order_qty_unit: "pallets",
  order_address_label: "Delivery Address",
  order_date_label: "Preferred Date",
  order_notes_label: "Additional Notes",
  order_next_steps: "Next Steps:",
  order_next_steps_desc: "After you submit this order, our team will review it and contact you within 24 hours to confirm pricing, availability, and delivery details.",
  order_edit: "Edit Order",
  order_confirm: "Confirm & Submit",
  order_submitting: "Submitting Your Order...",
  order_submitting_desc: "Please wait a moment.",
  order_success_title: "Order Submitted Successfully!",
  order_ref_label: "Reference Number",
  order_success_desc: "Thank you for your order! We will review your request and contact you within 24 hours to confirm pricing, availability, and delivery details.",
  order_close: "Close",
  order_error: "Something went wrong. Please try again or contact us directly.",

  // Footer
  footer_products: "Products",
  footer_contact: "Contact",
  footer_copyright: "© 2025 PEL Partner Company. All rights reserved.",
  footer_tagline: "Antwerp, Belgium — Euro Pallet Supplier",
  footer_desc: "Your trusted Euro pallet supplier in Antwerp, Belgium. Grade A, Grade B and new wooden pallets — quality guaranteed.",
  // Comparison Table
  compare_label: "Side by Side",
  compare_title: "Compare Our Pallet Grades",
  compare_subtitle: "Not sure which grade is right for you? Compare all three options at a glance.",
  compare_feature: "Feature",
  compare_grade_a: "Grade A",
  compare_grade_b: "Grade B",
  compare_new: "New Pallets",
  compare_condition: "Condition",
  compare_condition_a: "Excellent — minimal wear",
  compare_condition_b: "Good — minor cosmetic wear",
  compare_condition_new: "Brand new — unused",
  compare_certification: "Certification",
  compare_certification_a: "EPAL Certified",
  compare_certification_b: "Quality Inspected",
  compare_certification_new: "ISPM15 Certified",
  compare_load: "Load Capacity",
  compare_load_a: "Up to 1500 kg",
  compare_load_b: "Up to 1000 kg",
  compare_load_new: "Up to 2000 kg",
  compare_export: "Export Ready",
  compare_export_a: "EU only",
  compare_export_b: "EU only",
  compare_export_new: "Worldwide",
  compare_custom: "Custom Sizes",
  compare_custom_a: "No",
  compare_custom_b: "No",
  compare_custom_new: "Yes",
  compare_availability: "Availability",
  compare_availability_a: "In Stock",
  compare_availability_b: "In Stock",
  compare_availability_new: "Made to Order",
  compare_best_for: "Best For",
  compare_best_for_a: "Food-grade, sensitive goods",
  compare_best_for_b: "General warehousing",
  compare_best_for_new: "Export & international shipping",
  compare_starting_price: "Starting Price",
  compare_cta: "Order Now",
  compare_yes: "Yes",
  compare_no: "No",
};

export default translation;